module.exports = __webpack_public_path__ + "img/ic-ic-glasses.08bd2b81.svg";